import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, Autoplay } from "swiper";
import { AdvancedMarker, APIProvider, Map } from "@vis.gl/react-google-maps";

import AppointmentModal from "../AppointmentModal";

import "./PropertyDetail.css";
// Import Swiper styles
import "swiper/css";
import "swiper/css/autoplay";
import "react-calendar/dist/Calendar.css";

function PropertyDetail(props) {
  const position = {
    lat: props.property.latitude,
    lng: props.property.longitude,
  };

  //SwiperCore.use([Autoplay]);
  return (
    <section className="slice sct-color-1">
      <div className="row">
        <div className="col-lg-12">
          <div className="section-title section-title--style-1 mb-0">
            <h3 className="section-title-inner heading-sm strong-600 text-uppercase">
              <span>Propiedad {props.property.code}</span>
            </h3>
            <span className="section-title-delimiter clearfix d-none"></span>
            <div className="delimiter delimiter--style-1"></div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <h3 className="heading heading-3 strong-400">
            {props.property.show_address}
          </h3>
          <p>{props.property.property_type_name}</p>
          <h4 className="heading heading-sm strong-400">
            {" "}
            {props.property.description}{" "}
          </h4>
          <h3 className="heading heading-3 strong-600 c-base-1 mt-4 mb-4">
            {" "}
            {props.property.property_price}
          </h3>

          <p>{/* {props.property_description_facilities(@property)} */}</p>

          <div className="row">
            <div className="col-lg-12">
              <ul className="meta-info-cells meta-info-cells-v4">
                <li>
                  <i className="fa fa-home"></i> {props.property.area}{" "}
                  <span className="hidden-xs hidden-sm">Area</span>
                </li>
                <li>
                  <i className="fa fa-bed"></i> {props.property.rooms_count}{" "}
                  <span className="hidden-xs hidden-sm">Hab.</span>
                </li>
                <li>
                  <i className="fa fa-tint"></i>{" "}
                  {props.property.bathrooms_count}{" "}
                  <span className="hidden-xs hidden-sm">Baños</span>
                </li>
                <li>
                  <i className="fa fa-car"></i>{" "}
                  {props.property.parking_slots_count}{" "}
                  <span className="hidden-xs hidden-sm">Parqueadero</span>
                </li>
              </ul>
            </div>
          </div>
          <AppointmentModal property={props.property}></AppointmentModal>
          {/*<!-- Map canvas -->*/}
          <div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
            <APIProvider apiKey={"AIzaSyBwQrZwsWrEn-Xpvp2QQ8MSLKs_zCjDNjs"}>
              <Map
                defaultCenter={position}
                defaultZoom={17}
                mapId="DEMO_MAP_ID"
                style={{ height: "400px" }}
              >
                <AdvancedMarker position={position} />
              </Map>
            </APIProvider>
          </div>
        </div>

        <div className="col-lg-6">
          <Swiper
            modules={[Navigation, Pagination, Scrollbar, Autoplay]}
            spaceBetween={50}
            slidesPerView={1}
            navigation={{ enable: false }}
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            onSlideChange={() => console.log("slide change")}
            onSwiper={(swiper) => console.log(swiper)}
            style={{ height: "100%", paddingRight: "10px", paddingTop: "10px" }}
            className="swiper-container swiper-slider swiper-slider-2"
            autoplay={{ delay: 5000, disableOnInteraction: false }}
          >
            {props.property.images.map((image) => (
              <SwiperSlide key={image.url}>
                <img
                  key={image.id}
                  src={image.url}
                  alt={image.name}
                  className="img-fluid z-depth-3 rounded"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default PropertyDetail;
